import React, { Fragment } from 'react';
import styles from './BookLogHistoryItem.module.scss';
import { BookOpen, FileText } from 'react-feather';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

const BookLogHistoryItem = ({ log }) => {

    const { t } = useTranslation();
    return (
        <div className={styles.logItem}>
            <div className={styles.logItemHeader}>
                {log.isCompletion ? (
                    <Fragment>
                        <BookOpen className={cx(styles.logItemHeaderIcon, styles.logItemHeaderIconCompleted)} />
                        <span>{t('book_completed')}</span>
                    </Fragment>
                ) : (
                    <Fragment>
                        <FileText className={cx(styles.logItemHeaderIcon, styles.logItemHeaderIconPages)} />
                        <span>{t('log_added_pages')} {log.pageStart}&ndash;{log.pageEnd}</span>
                    </Fragment>
                )}
                <span className={styles.logItemHeaderDate}>{moment(log.date).format(("DD/MM/YYYY"))}</span>
            </div>
        </div >
    )
}

export default BookLogHistoryItem;
